import { Component, OnInit, OnDestroy } from '@angular/core';
import { TotalObject, CartTotalsService } from 'gung-standard';
import { Subscription } from 'rxjs';
import { ColmecNavbarCartService } from '../../../services/cart/colmec-navbar-cart.service';
import { map } from 'rxjs';

@Component({
    selector: 'colmec-cart-summary',
    templateUrl: './colmec-cart-summary.component.html',
    styleUrls: ['./colmec-cart-summary.component.scss'],
    standalone: false
})
export class ColmecCartSummaryComponent implements OnInit, OnDestroy {
  totals: TotalObject = { totalQuantity: 0, totalValue: 0, totalRows: 0 };
  currencyCode: string;
  private cartTotalsSubscription: Subscription;

  constructor(private cartTotalsService: CartTotalsService, private colmecNavbarCartService: ColmecNavbarCartService) {}

  ngOnInit() {
    this.cartTotalsSubscription = this.colmecNavbarCartService.getContents().subscribe(contents => {
      this.currencyCode = contents.currency;
      this.totals = { totalQuantity: 0, totalRows: 0, totalValue: contents.totalValue };
      return this.totals;
    });
  }

  ngOnDestroy() {
    if (!!this.cartTotalsSubscription) {
      this.cartTotalsSubscription.unsubscribe();
    }
  }
}
